import { gql } from "@apollo/client";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react";
import React, { useEffect, useState, useContext } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import NotificationsIcon from '@mui/icons-material/Notifications';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DoneAllIcon from '@mui/icons-material/DoneAll';

import { Badge, Button, IconButton } from '@mui/material';

import Notificacion from './components/Notificacion';

import '../../../../assets/css/App.css';
import ErrorDialog from '../../../../components/ErrorDialog';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { NotificacionContext } from '../../../../context/NotificacionContext';
import { DesktopOrTabletContainer, MobileContainer } from '../../../../responsiveTools/ResponsiveContainers';
import { CustomButton } from '../../../../components/customButton/CustomButton';

export default function NotificationSection() {

  const ESTADO_LEIDO = 1;
  const ESTADO_NO_LEIDO = 2;
  const CANTIDAD_NOTIFICACIONES_VISIBLES = 4;

  const { countNotificacionesNoLeidas, setCountNotificacionesNoLeidas, mensajes, setMensajes } = useContext(NotificacionContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorPosition, setAnchorPosition] = useState(null);
  const open = Boolean(anchorEl);

  const [loadingReadAll, setLoadingReadAll] = useState(false);
  const [heightRegistros, setHeightRegistros] = useState('365px');

  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
    setMensajeError("");
  };

  const idUsuario = parseInt(sessionStorage.getItem("idUsuario"), 10);
  const navigate = useNavigate();

  const QNotificacionesByFilters = gql`
    query QNotificacionesByFilters($idUsuario: Long!, $estado: Int!){
          notificacionesByFilters ( filtros: {
            idUsuario: $idUsuario,
            estado: $estado
          }
        )
        {
        success,
        error,
        valorEsperado {
          idNotificacion,
          idNotificacionTipo,
          idUsuario,
          fechaAlta,
          estado,
          titulo,
          descripcion,
          link,
          email,
          push,
          habilitado,
          totalNotificaciones,
          comentario
        }            
      }
    }`;

  const { data } = useQuery(QNotificacionesByFilters, {
    fetchPolicy: 'no-cache',
    variables: { idUsuario: idUsuario, estado: ESTADO_NO_LEIDO }
  });

  useEffect(() => {
    if (!data) return;
    try {
      if (data.notificacionesByFilters.success) {
        setMensajes(data.notificacionesByFilters.valorEsperado);
        const totalNotificaciones = data.notificacionesByFilters.valorEsperado.length > 0 ?
          data.notificacionesByFilters.valorEsperado[0].totalNotificaciones : 0;
        actualizarAltoNotificaciones(totalNotificaciones);
        setCountNotificacionesNoLeidas(totalNotificaciones);
      } else {
        setMensajeError(data.notificacionesByFilters.error);
      }
    } catch (e) {
      console.error('Error procesando notificaciones:', e);
    }
  }, [data]);

  const handleClick = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setAnchorPosition({
      top: rect.bottom,
      left: rect.right
    });
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setAnchorPosition(null);
  };

  const refrescarRegistros = () => {
    refrescar({ variables: { idUsuario: idUsuario, estado: ESTADO_NO_LEIDO } });
  };

  const [refrescar, { error: errorR, data: dataR }] = useLazyQuery(QNotificacionesByFilters, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataR) return;
    if (dataR.notificacionesByFilters.success) {
      setMensajes(dataR.notificacionesByFilters.valorEsperado);
      const totalNotificaciones = dataR.notificacionesByFilters.valorEsperado.length > 0 ?
        dataR.notificacionesByFilters.valorEsperado[0].totalNotificaciones : 0;
      actualizarAltoNotificaciones(totalNotificaciones);
      setCountNotificacionesNoLeidas(totalNotificaciones);
      if (totalNotificaciones === 0) {
        setAnchorEl(null);
      }
    } else {
      setMensajeError(dataR.notificacionesByFilters.error);
    }
  }, [dataR]);

  useEffect(() => {
    if (!errorR) return;
    setMensajeError("ERRORDB");
  }, [errorR]);

  const actualizarAltoNotificaciones = (cantidad) => {
    let total = cantidad;
    if (total === 0) {
      total = 1;
    } else if (total > CANTIDAD_NOTIFICACIONES_VISIBLES) {
      total = CANTIDAD_NOTIFICACIONES_VISIBLES;
    }
    setHeightRegistros(String(91.20 * total) + 'px');
  };

  const MSaveNotificacionEstadoMasivo = gql`
    mutation MSaveNotificacionEstadoMasivo ($idsNotificaciones: [Int!]!, $estado: Int!) {
        saveNotificacionEstadoMasivo
        (
            idsNotificaciones: $idsNotificaciones,
            estado: $estado
        )
        {
            success,
            error,
            valorEsperado
        }
    }`;

  const [marcarLecturaTodos, { data: dataAll, error: errorAll }] = useMutation(MSaveNotificacionEstadoMasivo);

  useEffect(() => {
    if (!dataAll) return;
    if (dataAll.saveNotificacionEstadoMasivo.success) {
      setLoadingReadAll(false);
      setCountNotificacionesNoLeidas(0);
      refrescarRegistros();
    } else {
      setMensajeError(dataAll.saveNotificacionEstadoMasivo.error);
      setLoadingReadAll(false);
    }
  }, [dataAll]);

  useEffect(() => {
    if (!errorAll) return;
    setMensajeError("ERRORDB");
    setLoadingReadAll(false);
  }, [errorAll]);

  const handleAllRead = () => {
    if (mensajes.length === 0) return;
    setLoadingReadAll(true);
    const ids = mensajes.map(mensaje => mensaje.idNotificacion);
    marcarLecturaTodos({
      variables: {
        idsNotificaciones: ids,
        estado: ESTADO_LEIDO
      }
    });
  };

  const handleViewAll = () => {
    setAnchorEl(null);
    navigate("/allNotificaciones");
  };

  const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      right: 0,
      top: 12,
      padding: '0 5px'
    }
  }));

  const menuContent = (
    <>
      <div style={{ maxHeight: heightRegistros, overflowX: 'hidden', overflowY: 'auto' }}>
        {
          mensajes.length === 0 ?
            <MenuItem style={{ fontSize: 13 }}>
              <strong>No existen Notificaciones pendientes de lectura.</strong>
            </MenuItem> :
            mensajes.map((mensaje) =>
              <Notificacion
                key={mensaje.idNotificacion}
                mensaje={mensaje}
                refrescarRegistros={refrescarRegistros}
                handleClose={handleClose}
              />
            )
        }
      </div>
      <MenuItem sx={{
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        gap: 1,
        px: 2,
        py: 1.5
      }}>
        <CustomButton
          onClick={handleViewAll}
          endIcon={<VisibilityIcon />}
          sx={{ fontSize: 10 }}
          variant="contained"
          size="small"
        >
          Ver Todas
        </CustomButton>
        <CustomButton
          disabled={mensajes.length === 0}
          endIcon={<DoneAllIcon />}
          loading={loadingReadAll}
          loadingPosition="end"
          onClick={handleAllRead}
          sx={{ fontSize: 10 }}
          variant="contained"
          size="small"
        >
          Marcar todas leídas
        </CustomButton>
      </MenuItem>
    </>
  );

  return (
    <>
      <StyledBadge badgeContent={countNotificacionesNoLeidas} color="primary">
        <IconButton onClick={handleClick}>
          <NotificationsIcon color="action" sx={{ cursor: 'pointer' }} />
        </IconButton>
      </StyledBadge>

      <Menu
        open={open}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={anchorPosition}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1,
            width: '400px',
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0
            }
          }
        }}
      >
        {menuContent}
      </Menu>

      <ErrorDialog
        id="dlg-error-notificaciones"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError}
      />
    </>
  );
}